import { render, staticRenderFns } from "./PageEvents.vue?vue&type=template&id=0b455d42&"
import script from "./PageEvents.vue?vue&type=script&lang=ts&"
export * from "./PageEvents.vue?vue&type=script&lang=ts&"
import style0 from "./PageEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports